import React, {useEffect} from 'react';
import Header from '../../partials/Header';
import PageIllustration from '../../partials/PageIllustration';
import PageIllustration2 from '../../partials/PageIllustration2';
import BlogSingle from '../../partials/BlogSingle';
import Footer from '../../partials/Footer';

function BlogPostEbam() {

  useEffect(() => {
    document.title = `eBAM : Sécurisation et digitalisation des pouvoirs bancaires| CPI Software`
  }, [])
  return (
    <div className="flex flex-col min-h-screen overflow-hidden">

      {/*  Site header */}
      <Header />

      {/*  Page content */}
      <main className="grow">
        <div className="relative max-w-6xl mx-auto h-0 pointer-events-none -z-1" aria-hidden="true">
          <PageIllustration />
          <PageIllustration2 />
        </div>
        {/*  Page sections */}
        <BlogSingle />
       
      </main>

      {/*  Site footer */}
      <Footer />

    </div>
  );
}

export default BlogPostEbam;